import { Building2, User } from 'lucide-react';

import CrmLink from '@/components/common/CrmLink';
import type { PartyData } from '@/features/party/types';
import { getPartyName } from '@/lib/party';

type Props = {
  party: NonNullable<PartyData['parties']>[number];
  onClick: () => void;
};

export default function PartyItem({ party, onClick }: Props) {
  return (
    <div
      className="flex w-full cursor-pointer items-center justify-between rounded-lg border p-2 transition-colors hover:bg-neutral-50 dark:hover:bg-neutral-800"
      onClick={() => onClick()}
    >
      <div className="flex grow items-center gap-2">
        <div className="bg-primary-100 dark:bg-primary-900 flex size-9 shrink-0 items-center justify-center rounded-lg">
          {party.type === 'COMPANY' ? (
            <Building2 className="text-primary-500 size-4" />
          ) : (
            <User className="text-primary-500 size-4" />
          )}
        </div>

        <div className="flex flex-col gap-1">
          <p className="text-sm leading-tight">{getPartyName(party)}</p>
          <p className="text-muted-foreground -mt-1 text-xs">{party.email}</p>
          <div className="text-muted-foreground flex flex-wrap gap-0.5 text-xs">
            {party.external_refs.map((ref) => (
              <CrmLink
                key={`${ref.company}-${ref.ref}`}
                ref={ref.ref}
                crm={ref.company}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
